import { render, staticRenderFns } from "./DashboardCard.vue?vue&type=template&id=a4a7a682&scoped=true"
import script from "./DashboardCard.vue?vue&type=script&lang=ts"
export * from "./DashboardCard.vue?vue&type=script&lang=ts"
import style0 from "./DashboardCard.vue?vue&type=style&index=0&id=a4a7a682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a7a682",
  null
  
)

export default component.exports